export const BUSINESS = {
  name: "HomeCare by Nicole",
  owner: "Nicole",
  credential: "Certified Nursing Assistant (CNA)",
  phoneDisplay: "(970) 623-0883",
  phoneHref: "tel:+19706230883",
  email: "nicole@homecarebynicole.com",
  emailHref: "mailto:nicole@homecarebynicole.com",
  area: "Grand Junction & Mesa County, CO",
  logo: "/logo.png",
};

export const IMAGES = {
  heroHands:
    "https://images.pexels.com/photos/36706840/pexels-photo-36706840.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  nicolePortrait:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_nicole-homecare/artifacts/1b5c8pes_Gemini_Generated_Image_jt4vhqjt4vhqjt4v.webp",
  companionCare:
    "https://images.pexels.com/photos/7345443/pexels-photo-7345443.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  personalCare:
    "https://images.unsplash.com/photo-1773227055624-07b515ba87c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export const SERVICES = [
  {
    key: "companion",
    icon: "HeartHandshake",
    title: "Companion Care",
    desc: "Company, meals, errands, and light housekeeping — the everyday warmth that makes a house feel like home.",
    span: "tall",
    image: IMAGES.companionCare,
  },
  {
    key: "personal",
    icon: "Sparkles",
    title: "Personal Care",
    desc: "Bathing, dressing, grooming, mobility, and hygiene — dignified, gentle, hands-on support.",
    span: "wide",
    image: IMAGES.personalCare,
  },
  {
    key: "senior",
    icon: "Users",
    title: "Senior & Elderly Care",
    desc: "Patient, attentive daily support tailored to your loved one's pace and needs.",
    span: "normal",
  },
  {
    key: "respite",
    icon: "Coffee",
    title: "Respite Care",
    desc: "A trusted break for family caregivers — rest easy knowing someone reliable is here.",
    span: "normal",
  },
  {
    key: "recovery",
    icon: "Activity",
    title: "Post-Surgery & Recovery Support",
    desc: "Help through the first tough weeks home, so healing happens where it's most comfortable.",
    span: "normal",
  },
];

export const TRUST = [
  "15+ Years Experience",
  "Certified Nursing Assistant",
  "High Standards & Genuine Compassion",
  "One Consistent Caregiver",
  "Serving Grand Junction & Mesa County",
];
